import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { Filter } from '../../../@types/filter';
import { userApi } from '../../../apis';
import ButtonWrap from '../../../components/ButtonWrap';
import SvgEye from '../../../components/svg/SvgEye';
import TableWrap from '../../../components/TableWrap';
import Widget from '../../../components/Widget';
import { OUT_OF_YEAR_MANAGEMENT } from '../../../constants/QueryKey';
import { ADMIN_ROUTE_NAME } from '../../../constants/RouteName';
import './style.scss';
import { useSelector } from 'react-redux';
import { EmployeeRelatedInformationDtoRolesEnum } from '../../../apis/client-axios';
import { RootState } from '../../../store';
const AnnualOvertime = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const role = useSelector((state: RootState) => state.auth.authUser?.role);
  const [filter, setFilter] = useState<Filter>({ page: 1, pageSize: 20, fullTextSearch: '' });
  const onClickDetail = (detail) => {
    navigate('/' + ADMIN_ROUTE_NAME.OUT_OF_YEAR_MANAGEMENT + `/${detail.id}`);
  };
  useEffect(() => {
    if (role && role !== EmployeeRelatedInformationDtoRolesEnum.Manager) {
      navigate(-1);
    }
  }, [navigate, role]);
  const { data: dataAnnualOvertime, isLoading } = useQuery({
    queryKey: [OUT_OF_YEAR_MANAGEMENT, filter],
    queryFn: () =>
      userApi.userControllerGetAllEmployeesByManager(filter.page, filter.pageSize, undefined, filter.fullTextSearch),
    enabled: !!filter,
  });

  const columns = [
    {
      title: intl.formatMessage({ id: 'annual.overtime.column.applicant' }),
      dataIndex: 'applicant',
      key: 'applicant',
      render: (_, record) => {
        return <p className="annual-overtime_table-column-data">{record.name}</p>;
      },
    },
    {
      title: '',
      dataIndex: 'option',
      key: 'option',
      render: (_, record) => {
        return (
          <ButtonWrap
            onClick={() => {
              onClickDetail(record);
            }}
            className=" annual-overtime_table-column-button"
          >
            <SvgEye />
            {intl.formatMessage({ id: 'attendance.management.button.view' })}
          </ButtonWrap>
        );
      },
    },
  ];
  return (
    <div className="annual-overtime">
      <Widget
        breadcrumbs={[intl.formatMessage({ id: 'annual.overtime.employee.breadcumb' })]}
        content={
          <TableWrap
            isPagination
            loading={isLoading}
            onSearch={(search) => {
              setFilter((prevFilters) => ({
                ...prevFilters,
                page: 1,
                fullTextSearch: search,
              }));
            }}
            tableProps={{
              dataSource: Array.isArray(dataAnnualOvertime?.data?.data?.content)
                ? dataAnnualOvertime?.data?.data?.content
                : [],
              columns,
              className: 'annual-overtime_table',
              scroll: { x: 1000 },
            }}
            paginationProps={{
              current: dataAnnualOvertime?.data?.data?.page || 1,
              pageSize: dataAnnualOvertime?.data?.data?.size || 20,
              total: dataAnnualOvertime?.data?.data?.total || 0,
              onChange: (page, pageSize) =>
                setFilter((prevFilters) => ({
                  ...prevFilters,
                  page,
                  pageSize,
                })),
            }}
          />
        }
        title={intl.formatMessage({ id: 'annual.overtime.employee.title' })}
      />
    </div>
  );
};
export default AnnualOvertime;
